<template>


  <div class="page">
    <XHeader></XHeader>
    <div class="container">
      <XLeft></XLeft>
      <div class="maintainer">
        <router-view/>
      </div>
    </div>
    <!--子组件-->

  </div>
</template>

<script>
  import Left from '@/components/layout/Left'
  import Header from '@/components/layout/Header'
  import  {CheckToken} from '../../mixins/CheckToken'

  export default {
    name: "",
    components: {
      XLeft: Left,
      XHeader: Header
    },
    mixins:[CheckToken]
  }
</script>

<style scoped>
  .container {
    position: absolute;
    top: 61px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  .maintainer {
    position: absolute;
    left: 210px;
    top: 0px;
    right: 10px;
    bottom: 0;
    overflow: auto;
    background-color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/components/layout/Page.vue